import { restApiIP } from "@plannel/services/utils/rest-api";

const get = (id) => {
  return restApiIP.get(`/api/abc/analysis/scenarios/${id}`);
};

const run = data => {
  return restApiIP.post("/api/abc/analysis/scenarios/run", data);
};

const abcAnalysisScenariosService = {
  get,
  run
};

export default abcAnalysisScenariosService;